import { getMeOptions } from "@sunner-cloud/api-client";
import { useQuery } from "@tanstack/react-query";

import { useAuth } from "./useAuth";

export const useUser = () => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    ...getMeOptions(),
    enabled: isAuthenticated,
  });
};
